import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HomeV1 from "./pages/HomeV1";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/v1" element={<HomeV1 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;